var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"operator simple",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.listeners.add($event)}}},[_c('div',{staticClass:"mc-icon-wrap"},[_c('IconFont',{attrs:{"name":"mc-icon-jia","color":_vm.props.canBuy ? '#15bb5c' : '#bbb',"size":"20px"}}),(_vm.props.showCount && _vm.props.count)?_c('p',{class:[
        'count',
        {
          'over-num': _vm.props.count > 99
        }
      ]},[_vm._v(" "+_vm._s(_vm.props.count > 99 ? '...' : ("" + (_vm.props.count)))+" ")]):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }